/*
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */

/* global restCollection, Promise, schema */

/** TODO remove this note
 * Add some nice REST functions the object.
 * <i>save()</i>, <i>destroy()</i> to the main object.
 * Also <i>add()</i>, <i>remove()</i> to each collection.<br>
 * <i>save</i> will only save attributes, not collections.<br>
 * Call <i>add()</i>, <i>remove()</i> only with id.
 * @param {type} object
 * @returns {undefined}
 */

/**
 * Represents an instance of a dataset with some usefull functions.
 * @param {Rest} rest
 * @param {type} data
 * @returns {RestSubject}
 */
function RestSubject(rest, data) {
  if (!this instanceof RestSubject) return new RestSubject(rest, data);

  var that = this;

  // -- attributes --
  this.objectPath;
  this.data = {};

  /**
   * @type Rest
   */
  this._rest = rest;

  // -- public functions --
  this.reload = reload;
  this.save = save;
  this.destroy = destroy;
  this.checkBehavior = checkBehavior;

  // init
  (function () {
    that.objectPath = that._rest.endPoint + "/";
    if (data && data.id) {
      that.data.id = data.id;
      that.objectPath += that.data.id;
    }
    //catch empty populations and add add(), remove()
    for (let key in that._rest.schemaData) {
      let schemaItem = that._rest.schemaData[key];
      if (!schemaItem.getData) {
        switch (schemaItem.type) {
          case "collection":
            that.data[key] = upgradeCollection(data[key], key);
            break;
          default:
            that.data[key] = data[key];
        }
      } else {
        that.data[key] = schemaItem.getData(data);
      }
    }
  })();

  /**
   * Reloades objects attributes and collections.
   * Note that the pointer of the object will be the same. Only the values will be changed.
   * @param {string} id
   * Optional id. For the case the object got a new id after a <i>save()</i>.
   * @returns {Promise}
   * Resolves with <i>null</i> on any error.
   */
  function reload(id) {
    if (id) {
      that.data.id = id;
      that.objectPath = that._rest.endPoint + "/" + id;
    }

    return that._rest
      .request("GET", that.objectPath + "?populate")
      .then((xhr) => {
        if (xhr.status !== 200) throw xhr;

        var reloadedData = JSON.parse(xhr.responseText);
        if (!reloadedData) throw xhr;

        // !! Do not change the pointer of the object varable !!
        for (var key in that._rest.schemaData) {
          var schemaItem = that._rest.schemaData[key];
          if (!schemaItem.getData) {
            switch (schemaItem.type) {
              case "collection":
                //recreate the collection
                that.data[key] = upgradeCollection(reloadedData[key], key);
                break;
              default:
                that.data[key] = reloadedData[key];
            }
          } else {
            that.data[key] = schemaItem.getData(data);
          }
        }
        return that;
      });
  }

  /**
   * Saves the edited object. Note: Only regular attributes will be saved.
   * Changes on collections will be ignored here.<br>
   * Note: Some APIs clone objects instead of updating them.
   * You could recognize this by checking objects id.<br>
   * If object has no id <i>POST<i> will be used. After this the object should
   * be created on server and prodives an id.
   * @returns {Promise}
   * Will be resolved or rejected with xhr.
   */
  function save() {
    var data = {};
    var httpMethod = that.data.id ? "PUT" : "POST";

    //validate object before creation by schema
    if (
      httpMethod === "POST" &&
      that._rest.schema.beforeCreate &&
      !that._rest.schema.beforeCreate(that.data)
    ) {
      return new Promise((resolve, reject) => reject("beforeCreate faild"));
    }

    var files = [];

    for (var key in that._rest.schemaData) {
      var schemaItem = that._rest.schemaData[key];
      if (!schemaItem.getData) {
        switch (schemaItem.type) {
          case "static":
            data[key] = that.data[key];
            break;
          case "collection":
            //do not use collections on update() cause of mayby removeing items from collection
            //witch are not visible to user (api should ignore collections here anywhere)

            if (httpMethod === "POST")
              data[key] = that.data[key].map(
                (collectionItem) => collectionItem.data.id
              ); //take only the id
            break;
          case "file": //file have to be send with its own request
            var file = that.data[key];
            if (!file) continue;
            var fileData = {
              schema: schemaItem.via || key,
              file: file,
              data: {},
            };
            files.push(fileData);
            //add this subject as a parent

            if (that.data.id)
              fileData.data[that._rest.schemaKey] = that.data.id;
            else fileData.data[that._rest.schemaKey] = that.data.form;

            break;
          default:
            data[key] = that.data[key];
        }
      } else {
        data[key] = schemaItem.getData(data);
      }
    }

    var saveResult;
    var savePromise = that._rest
      .request(httpMethod, that.objectPath, data)
      .then((xhr) => {
        switch (xhr.status) {
          case 200:
            return reload();
          case 201: //object was cloned
            var jsonResult = JSON.parse(xhr.responseText);
            var id = jsonResult.id;

            if (!id && jsonResult.length > 0) {
              id = jsonResult[0].id;
            }
            return reload(id);
          default:
            throw xhr;
        }
      })
      .then((sr) => {
        saveResult = sr;
        return Promise.all(
          files.map((fileData) => {
            /**
             * @type Rest
             */
            var fileRest = restCollection[fileData.schema];
            var fileSchema = schema[fileData.schema];

            //method, url, file, data
            return fileRest.fileUpload(
              "POST",
              fileSchema.endPoint,
              fileData.file,
              fileData.data
            );
          })
        );
      })
      .catch((e) => {
        throw e;
      })
      .then(() => saveResult);

    return savePromise;
  }

  /**
   * Try to delete object.<br>
   * Note: Some APIs only set the <i>active</i> attribute to false.
   * You could recognize this be checking if the promise will be resolved with an object instead of null.
   * @returns {Promise}
   */
  function destroy() {
    return that._rest
      .request("DELETE", that.objectPath)
      .then((xhr) => {
        if (xhr.status !== 200) {
          throw xhr;
        }
        return xhr;
      })
      .then((xhr) => reload());
  }

  function checkBehavior() {
    var url = that._rest.endPoint + "/checkBehavior/" + that.data.id;
    return that._rest.request("GET", url).then((xhr) => {
      if (xhr.status !== 200) throw xhr;
      return JSON.parse(xhr.responseText);
    });
  }

  /**
   * Upgrades the collection with RESTfull <i>add()</i> and <i>remove()</i>
   * @param {Array} collection
   * @param {string} collectionKey
   * @returns {Array|RestSubject.upgradeCollection.collection}
   */
  function upgradeCollection(collection, collectionKey) {
    //make surce collection will be not undefined or null
    if (!collection) collection = [];

    collection.add = add;
    collection.remove = remove;

    return collection;

    /**
     * Add a new item to objects collection by id.
     * @param {string} id
     * @returns {Promise}
     */
    function add(id) {
      //object existing on server
      if (that.data.id) {
        var path = that.objectPath + "/" + collectionKey + "/" + id;
        return that._rest
          .request("POST", path)
          .then((xhr) => {
            switch (xhr.status) {
              case 200:
              case 201:
                return xhr;
              default:
                throw xhr;
            }
          })
          .then((xhr) => reload())
          .catch((xhr) => {
            throw xhr.status;
          });
      }

      //object not yet on server: simulate.
      var collectionSchemaKey =
        that._rest.schemaData[collectionKey].via || collectionKey;
      /**
       * @type Rest
       */
      var collectionRest = restCollection[collectionSchemaKey];
      return collectionRest.findOne(id).then((collectionItem) => {
        collection.push(collectionItem);
        return that;
      });
    }

    /**
     * Remove an item from objects collection by id.
     * @param {string} id
     * @returns {Promise}
     */
    function remove(id) {
      //object existing on server
      if (that.data.id) {
        var path = that.objectPath + "/" + collectionKey + "/" + id;
        return that._rest
          .request("DELETE", path)
          .then((xhr) => {
            if (xhr.status !== 200) throw xhr;

            return xhr;
          })
          .then((xhr) => reload())
          .catch((xhr) => {
            throw xhr.status;
          });
      }

      //object not yet on server: simulate.
      return new Promise((resolve, reject) => {
        //find index of item and remove it with splice. this avoids creation of a new array instance
        //do not use filter since the collection array is upgraded with additional functions
        for (var i = 0, len = collection.length; i < len; i++) {
          if (collection[i].id === id) {
            collection.splice(i, 1);
            break;
          }
        }
        resolve(that);
      });
    }
  }
}
